Backbone = require 'backbone'
Backbone.$ = $

class EmailFormIntlBaseDateInputView extends Backbone.View

  initialize: (options) ->
    @options = options || {}
    @I18nScope = 'modules.support'
    @isInputFieldEmpty = true
    @maxLength = 250
    @base_template = @options.template
    @model = @options.model
    @isFlexibleStepThree = @options.isFlexibleStepThree
    @label = @model.label
    @isInputCompulsory = @model.required is true or @model.required is "true"
    @show_template = {}

  render: ->
    @$el.html(toHtml(@base_template, @toHash()))
    @$el.find(@elementID).datepicker()

  toHash: ->
    hash =
      stepThreeType: if @isFlexibleStepThree then 'flexibleStepThree' else 'defaultStepThree'
      label: @label
      required: @isInputCompulsory
      maxLength: @maxLength
      counter: @model.counter
      options: @dropdownOptions
      show_dropdown: @dropdownOptions?.length > 0
    _.extend @show_template, hash

  getInputHtmlElement: ->
    @$el.find(@elementID)

  isInputGiven: ->
    @getInputHtmlElement().val().trim().length > 0

  isInputValid: ->
    true

  validateEmailForm: ->
    if @isInputCompulsory && ((@isInputFieldEmpty && @isInputGiven()) || !(@isInputFieldEmpty || @isInputGiven()))
      @isInputFieldEmpty = !@isInputGiven()
      @options.validateEmailForm()

  populateInput: (data)->
    if @isInputGiven()
      inputData = @readInput()
      data.description += "\n\n #{@label} : #{inputData}"

  deleteKeyDownHandler: (e)->
    if(e.keyCode is 8)
      e.stopPropagation()
      e.preventDefault()
      return false

module.exports = EmailFormIntlBaseDateInputView
